// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__28CLz"};